import React from 'react';
import { Content } from './shared';

const UniversalColonCancerScreening = () => (
  <Content>
    Your risk level for colorectal cancer will determine how often you should get screened. Ask your
    physician if you qualify.
  </Content>
);

export default UniversalColonCancerScreening;
